<template>
    <v-layout>
        <v-flex>
            <v-toolbar flat>
                <h3 class="font-weight-light black--text">{{title}}</h3>
                <v-spacer></v-spacer>
                <v-btn class="mr-1" color="blue" outlined v-for="option in getOptions" :key="option.nome" @click="option.action"> {{ option.nome }} </v-btn>
            </v-toolbar>
            <v-container :fluid="true">
                <slot></slot>
            </v-container>
        </v-flex>
    </v-layout>
</template>
<script>
    export default{
        props: ['title', 'options'],
        computed: {
            getOptions() {
                let opt = []
                
                if(this.options) {
                    opt = this.options
                }

                return opt
            }
        }
    }
</script>